<template>
  <!-- 新增赠品 -->
  <div class="addGift">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title"></page-header>
    <!-- 表单容器 -->
    <el-scrollbar
      style="
        height: calc(100% - 60px);
        padding-top: 20px;
        box-sizing: border-box;
      "
    >
      <el-form
        :model="addForm"
        label-position="rigth"
        label-width="100px"
        :rules="addFormRule"
        ref="addForm"
      >
        <div class="form-item-wrap">
          <el-form-item label="商品类型" prop="goodsType">
            <el-select
              v-model="addForm.goodsType"
              placeholder="商品类型"
              clearable
              @change="GoodsChangeType"
              style="width: 200px"
            >
              <el-option
                v-for="(item, index) in erpTypeNameList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品名称" prop="name">
            <el-input
              @change="GoodsChangeType"
              v-model="addForm.name"
              v-if="addForm.goodsType == 'GT3'"
              clearable
              style="width: 200px"
            ></el-input>
            <el-input
              v-model="addForm.name"
              v-else
              clearable
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="商品规格" prop="specification">
            <el-input
              v-model="addForm.specification"
              clearable
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item label="包装单位" prop="packingNnit">
            <el-input
              v-model="addForm.packingNnit"
              clearable
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="生产厂家" prop="producer">
            <el-input
              v-model="addForm.producer"
              clearable
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item label="建议零售价" prop="repertory">
            <el-input
              v-model="addForm.repertory"
              clearable
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="库存" prop="retailPrice">
            <el-input
              v-model="addForm.retailPrice"
              clearable
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item label="排序值" prop="sort">
            <el-input
              v-model="addForm.sort"
              clearable
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap" style="margin-top: 20px">
          <!-- <el-form-item label="封面图片" prop="view">
            <img-upload action="" @fallback="imgFallback"></img-upload>
          </el-form-item> -->
          <el-form-item label="选择图片" prop="view">
            <img-view :imgList="[{ url: $setImgUrl(addForm.view), id: 0 }]">
            </img-view>
            <upload
              @fileChange="beforeAvatarUpload"
              accept="image/jpg,image/jpeg,image/png"
            >
            </upload>
          </el-form-item>
        </div>

        <div class="form-item-wrap">
          <el-form-item label="" prop="">
            <el-button type="primary" @click="submit">提交</el-button>
            <el-button type="info" @click="resetForm">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-scrollbar>
    <el-dialog
      title="选择优惠券"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="80%"
    >
      <search-bar>
        <template>
          <el-input
            style="width: 200px; margin-right: 5px"
            clearable
            placeholder="输入编号/名称"
            v-model="searchUser"
          >
          </el-input>
          <el-button type="primary" icon="el-icon-search" @click="search"
            >搜索</el-button
          >
          <!-- <el-button type="primary" icon="el-icon-circle-check" @click="submit"
            >确定
          </el-button> -->
        </template>
      </search-bar>
      <el-table
        stripe
        height="500px"
        width="100%"
        border
        :data="tableList"
        @row-click="rowClick"
        row-key="code"
        ref="selectiontt"
        element-loading-text="拼命加载中..."
        v-loading="loading"
      >
        <el-table-column
          width="50"
          type="selection"
          align="center"
          :reserve-selection="true"
        ></el-table-column>
        <el-table-column type="index" label="序号" align="center">
          <template slot-scope="scope">
            <span>{{
              (currentchange_vlue - 1) * pagesize_value + scope.$index + 1
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="GoodsCode"
          label="编号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="GoodsName"
          label="名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="StockQuantity"
          label="数量"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="DrugSpec"
          label="类型"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="PackageUnit"
          label="单位"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="DrugFactory"
          label="描述"
          align="center"
        ></el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentchange_vlue"
        :page-size="pagesize_value"
        layout="total,prev, pager, next, jumper,sizes"
        :total="totalnumber"
        prev-text="上一页"
        next-text="下一页"
        :page-sizes="pagesize"
        @size-change="getsizechange"
        @current-change="getcurrentchange"
      ></el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import { mustFill } from "@/mixins/data/valid.js"; //混入表单必填项
export default {
  name: "addGift",
  data() {
    return {
      /**新增表单 */
      //商品名称 商品规格 包装单位 生产厂家 建议零售价 库存 封面图片 排序值
      addForm: {
        id: "",
        name: "",
        specification: "",
        packingNnit: "",
        producer: "",
        repertory: "",
        retailPrice: "",
        view: "",
        sort: "1",
        goodsType: "GT2",
        goodsName: "",
        goodscode: "",
      },
      /**新增表单规则 */
      addFormRule: {
        id: [mustFill],
        name: [mustFill],
        specification: [mustFill],
        packingNnit: [mustFill],
        producer: [mustFill],
        repertory: [mustFill],
        retailPrice: [mustFill],
        view: "",
        sort: [mustFill],
        goodsType: [mustFill],
      },
      // 商品类型
      erpTypeNameList: [
        { value: "GT2", label: "普通商品" },
        {
          value: "GT3",
          label: "优惠券",
        },
      ],
      // 选择优惠券类型，优惠券弹框
      dialogVisible: false,
      tableList: [], //优惠券表格
      //表格下面分页
      userIds: "", //勾选的客户
      currentPage: 1,
      totalnumber: 0, //总条数
      pagesize_value: 25, //默认设置页数量
      currentchange_vlue: 1, //总页码
      pagesize: [25, 50, 100, 200],
      loading: false,
      searchUser: "",
      tableListInfo: [],
    };
  },
  components: {},
  methods: {
    /**商品图片上传 */
    beforeAvatarUpload(file) {
      //  ('goods','GiftImg','goodsfile')
      //  console.log(file)
      if (file.length) {
        this.addForm.view = URL.createObjectURL(file[0]);
        var uploadfile = new FormData();
        uploadfile.append("uploadfile", file[0]);
        var imgType = this.addForm.imgClassify;
        if (imgType == "") {
          this.$message({
            message: "上传失败,请选择图片分类",
            type: "info",
          });
          return;
        }
        this.$uploadRequest({
          url: "admin/ashx/UploadImg.ashx?type=UploadImage&imgType=goods",
          data: uploadfile,
          method: "post",
        })
          .then((res) => {
            // this.addForm.view = this.$setImgUrl(res.message);
            // 改为了不进行地址补全
            this.addForm.view = res.message;
          })
          .catch((err) => {
            window.console.log(err);
          });
      }
    },
    // 查询未绑定的客户
    search() {
      this.currentchange_vlue = 1;
      this.getGoodsSelect();
    },
    GoodsChangeType() {
      if (this.addForm.goodsType == "GT3") {
        this.dialogVisible = true;
        this.getGoodsSelect();
      }
    },
    // 获取促销商品
    getGoodsSelect() {
      this.loading = true;
      this.$request({
        method: "post",
        url: "Management/ActivityAdmin/GetGoodsSelectionList",
        data: {
          valStr: this.searchUser,
          goodsType: "GT3",
          pageIndex: this.currentchange_vlue,
          pageSize: this.pagesize_value,
        },
      })
        .then((res) => {
          if (res.success) {
            this.loading = false;
            this.tableList = res.dataList;
            this.totalnumber = res.recordCount;
          } else {
            this.loading = false;
            this.tableList = [];
            this.totalnumber = 0;
          }

          console.log(res);
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 选择单条数据
    rowClick(section) {
      console.log(section, "2323");
      this.addForm.goodscode = section.GoodsCode;
      this.addForm.name = section.GoodsName;
      this.addForm.specification = section.DrugSpec;
      this.addForm.packingNnit = section.PackageUnit;
      this.addForm.producer = "";
      this.addForm.repertory = section.Price;
      this.addForm.retailPrice = section.StockQuantity;
      this.addForm.sort = 1;
      this.dialogVisible = false;
    },
    //页数选择
    getsizechange(val) {
      let _this = this;
      this.currentchange_vlue = 1;
      _this.pagesize_value = val;
      this.getGoodsSelect();
    },
    //选择分页页数
    getcurrentchange(val) {
      let _this = this;
      _this.currentchange_vlue = val;
      this.getGoodsSelect();
    },
    /**提交新增分类 */
    submit() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          var data = {
            type: "GiftSave",
            id: this.addForm.id,
            sort_id: this.addForm.sort,
            goodsname: this.addForm.name,
            img_url: this.addForm.view,
            Inventory: this.addForm.retailPrice,
            Price: this.addForm.repertory,
            package_unit: this.addForm.packingNnit,
            drug_factory: this.addForm.producer,
            drug_spec: this.addForm.specification,
            goodscode: this.addForm.goodscode,
            GoodsType: this.addForm.goodsType,
          };
          var proc = "Proc_Admin_GiftList"; //存储过程名
          var type = "ReturnNumber";
          this.$requestSys({
            url:
              "brand/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "Post",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                for (const key in this.addForm) {
                  this.addForm[key] = null;
                }
                this.goBack();
              } else {
                this.$message({
                  message: res.message,
                  type: "info",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        }
      });
    },
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },
    /**重置*/
    resetForm() {
      this.$refs.addForm.resetFields();
    },
  },
};
</script>

<style scoped>
.addGift {
  width: 100%;
  height: 100%;
}
.form-item-wrap {
  display: flex;
  padding: 0 0 0 20px;
  box-sizing: border-box;
}
</style>
